/* HAFA Beispielkalkulationen (08/2026)
 * Preislogik identisch zum [Pricing]-Script in theme.liquid:
 * - Stufenpreise aus der Google-Sheet-Matrix (EUR, DE-Brutto, bereits × 0,96748)
 * - EUR erst auf Cent quantisieren, DANN × Shopify.currency.rate (= Cart-Verhalten)
 * - Zepto-Aufpreise: Rohwert (EUR inkl. 23 % PL-MwSt) × 0,96748 × Kurs
 * Mengenregeln je Zeile (Attribut data-rule) — identisch zum Bedarfs-Planer
 * (assets/measurement-planner.js): fix | stairs (+Versatz) | per_stair (×Faktor,
 * aufgerundet, Kleber 1,3333) | divide (÷Teiler, aufgerundet, Silikon 7).
 * WICHTIG: Fallback-Matrix synchron halten mit theme.liquid ([Pricing]-Fallback)!
 */
(function () {
  'use strict';

  // Das Script wird von jeder Section-Instanz eingebunden — nur einmal initialisieren,
  // sonst stapeln sich die Event-Listener (Stepper zählt dann pro Klick mehrfach).
  if (window.__hafaKalkInit) return;
  window.__hafaKalkInit = true;

  var SHEET_URL = 'https://docs.google.com/spreadsheets/d/e/2PACX-1vQ6PdnsHCoWUZOEGKqJRGuR4Lmaqf9TG8wWvIYrRuwLxtKgPrv4zHufScdup2ERKA/pub?gid=1783061605&single=true&output=csv';
  var FACTOR = 0.96748; // 1,19 / 1,23 — MwSt-Angleich für Zepto-Rohwerte

  var FALLBACK_MATRIX = {
    80:  { 26.5: 53.2114, 32.5: 62.8862, 38.5: 72.5610, 63.5: 91.9106 },
    100: { 26.5: 67.7236, 32.5: 79.3333, 38.5: 90.9431, 63.5: 114.1626 },
    130: { 26.5: 82.2358, 32.5: 95.7805, 38.5: 109.3252, 63.5: 136.4146 },
    160: { 26.5: 96.7480, 32.5: 112.2276, 38.5: 127.7073, 63.5: 158.6667 },
    180: { 26.5: 111.2602, 32.5: 128.6748, 38.5: 146.0894, 63.5: 180.9187 }
  };

  var matrix = FALLBACK_MATRIX;

  var rate = 1;
  var currency = 'EUR';
  try {
    if (window.Shopify && window.Shopify.currency) {
      rate = parseFloat(window.Shopify.currency.rate) || 1;
      currency = window.Shopify.currency.active || 'EUR';
    }
  } catch (e) {}

  var lang = (document.documentElement.lang || 'pl').slice(0, 2);

  // Währungsformat aus Shopifys eigenem money-Filter ableiten (data-money-sample),
  // damit berechnete Zeilen exakt wie die serverseitig gerenderten aussehen
  // ("83,60 zł" statt "83,60 PLN"). Fallback: Intl.
  function buildFormatter() {
    var sampleEl = document.querySelector('[data-money-sample]');
    var sample = sampleEl && sampleEl.getAttribute('data-money-sample');
    if (sample) {
      var first = sample.search(/\d/);
      var last = sample.length - 1 - String(sample).split('').reverse().join('').search(/\d/);
      if (first > -1 && last >= first) {
        var prefix = sample.slice(0, first);
        var suffix = sample.slice(last + 1);
        var body = sample.slice(first, last + 1);
        var seps = body.replace(/\d/g, '');
        var decimal = '', thousands = '', decimals = 0;
        if (seps.length) {
          var lastSep = seps.charAt(seps.length - 1);
          var tail = body.split(lastSep).pop().length;
          if (tail === 2) {           // letzter Separator trennt die Nachkommastellen
            decimal = lastSep;
            decimals = 2;
            thousands = seps.length > 1 ? seps.charAt(0) : '';
          } else {                     // Format ohne Dezimalstellen (money_with_no_decimals)
            thousands = seps.charAt(0);
          }
        }
        return { format: function (v) {
          var neg = v < 0;
          var fixed = Math.abs(v).toFixed(decimals);
          var parts = fixed.split('.');
          var intPart = parts[0];
          if (thousands) intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
          var out = intPart + (parts[1] ? decimal + parts[1] : '');
          return (neg ? '-' : '') + prefix + out + suffix;
        } };
      }
    }
    try {
      return new Intl.NumberFormat(lang === 'de' ? 'de-DE' : 'pl-PL', { style: 'currency', currency: currency });
    } catch (e) {
      return { format: function (v) { return v.toFixed(2) + ' ' + currency; } };
    }
  }
  var fmt = { format: function (v) { return v.toFixed(2); } };

  function round2(v) { return Math.round(v * 100) / 100; }
  function num(v) { var n = parseFloat(String(v == null ? '' : v).replace(',', '.')); return isNaN(n) ? null : n; }

  function parseCSVLine(line) {
    var result = [], current = '', inQuotes = false;
    for (var i = 0; i < line.length; i++) {
      var ch = line[i];
      if (ch === '"') { inQuotes = !inQuotes; }
      else if (ch === ',' && !inQuotes) { result.push(current); current = ''; }
      else { current += ch; }
    }
    result.push(current);
    return result;
  }

  function parseCSVToMatrix(csv) {
    var m = {};
    var lines = csv.trim().split(/\r?\n/);
    if (lines.length < 2) return m;
    var header = parseCSVLine(lines[0]);
    var depths = [];
    for (var i = 1; i < header.length; i++) {
      var val = header[i].trim().replace(/(\d),(\d)/g, '$1.$2');
      var n = parseFloat(val);
      if (!isNaN(n) && n > 0) depths.push(n);
    }
    if (!depths.length) return m;
    for (var r = 1; r < lines.length; r++) {
      var line = lines[r].trim();
      if (!line) continue;
      var parts = parseCSVLine(line);
      var width = parseInt(parts[0], 10);
      if (isNaN(width)) continue;
      m[width] = {};
      for (var c = 0; c < depths.length; c++) {
        var raw = (parts[c + 1] || '').replace(/[^\d.,]/g, '').replace(/(\d),(\d)/g, '$1.$2');
        var p = parseFloat(raw);
        if (!isNaN(p) && p > 0) m[width][depths[c]] = p;
      }
    }
    return m;
  }

  function matrixLooksValid(m) {
    return m && m[80] && m[80][26.5] > 0;
  }

  // Menge einer Zeile nach Regel und Stufenanzahl N bestimmen
  function computeQty(row, N) {
    var base = parseInt(row.getAttribute('data-qty'), 10) || 1;
    var rule = row.getAttribute('data-rule') || 'fix';
    var val = num(row.getAttribute('data-rule-value'));
    if (N == null || rule === 'fix') return base;
    if (rule === 'stairs') return Math.max(0, Math.round(N + (val || 0)));
    if (rule === 'per_stair') return Math.ceil(N * (val || 1));
    if (rule === 'divide') return Math.ceil(N / (val || 1));
    return base;
  }

  function unitPrice(row) {
    var type = row.getAttribute('data-calc-row');
    if (type === 'step') {
      var w = parseInt(row.getAttribute('data-width'), 10);
      var d = parseFloat(row.getAttribute('data-depth'));
      var eur = matrix[w] && matrix[w][d];
      return eur ? round2(round2(eur) * rate) : null;
    }
    if (type === 'zepto') {
      var raw = num(row.getAttribute('data-eur'));
      return raw == null ? null : round2(round2(raw * FACTOR) * rate);
    }
    if (type === 'custom') {
      var eurDe = num(row.getAttribute('data-eur-de'));
      return eurDe == null ? null : round2(round2(eurDe) * rate);
    }
    if (type === 'variant') {
      var cents = parseInt(row.getAttribute('data-cents'), 10);
      return isNaN(cents) ? null : cents / 100; // bereits Präsentationswährung
    }
    return null;
  }

  function getState(section) {
    var stepsInput = section.querySelector('[data-calc-steps]');
    var ledInput = section.querySelector('[data-calc-led]');
    var N = null;
    if (stepsInput) {
      var min = parseInt(stepsInput.min, 10) || 1;
      var max = parseInt(stepsInput.max, 10) || 50;
      N = parseInt(stepsInput.value, 10);
      if (isNaN(N)) N = min;
      N = Math.min(max, Math.max(min, N));
      stepsInput.value = N;
    }
    return { N: N, led: ledInput ? ledInput.checked : true };
  }

  function calcSection(section) {
    var state = getState(section);
    var sums = { main: 0, extra: 0 };

    section.querySelectorAll('[data-calc-row]').forEach(function (row) {
      var ledOnly = row.hasAttribute('data-led-only');
      if (ledOnly) row.hidden = !state.led;
      var active = !ledOnly || state.led;

      var qty = computeQty(row, state.N);
      var unit = unitPrice(row);
      var qtyCell = row.querySelector('[data-cell="qty"]');
      if (qtyCell) qtyCell.textContent = qty > 1 || row.getAttribute('data-calc-row') !== 'custom' ? qty : '';
      row.setAttribute('data-calc-qty-now', qty);

      if (unit == null) return;
      var total = round2(unit * qty);
      var unitCell = row.querySelector('[data-cell="unit"]');
      var totalCell = row.querySelector('[data-cell="total"]');
      if (unitCell) unitCell.textContent = fmt.format(unit);
      if (totalCell) totalCell.textContent = fmt.format(total);

      if (!active || qty <= 0) return;
      var group = row.getAttribute('data-group') === 'extra' ? 'extra' : 'main';
      sums[group] += total;
    });

    sums.main = round2(sums.main);
    sums.extra = round2(sums.extra);
    var grand = round2(sums.main + sums.extra);
    var el;
    if ((el = section.querySelector('[data-cell="sum-main"]'))) el.textContent = fmt.format(sums.main);
    if ((el = section.querySelector('[data-cell="sum-extra"]'))) el.textContent = fmt.format(sums.extra);
    if ((el = section.querySelector('[data-cell="sum-grand"]'))) el.textContent = fmt.format(grand);
  }

  function initControls(section) {
    var stepsInput = section.querySelector('[data-calc-steps]');
    if (stepsInput) {
      stepsInput.addEventListener('change', function () { calcSection(section); });
      section.querySelectorAll('[data-calc-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var delta = parseInt(btn.getAttribute('data-calc-step'), 10) || 0;
          stepsInput.value = (parseInt(stepsInput.value, 10) || 0) + delta;
          calcSection(section);
        });
      });
    }
    var ledInput = section.querySelector('[data-calc-led]');
    if (ledInput) {
      ledInput.addEventListener('change', function () { calcSection(section); });
    }
  }

  function initAddToCart(section) {
    var btn = section.querySelector('[data-calc-add]');
    if (!btn) return;
    btn.addEventListener('click', function () {
      var items = [];
      section.querySelectorAll('[data-calc-row="variant"]').forEach(function (row) {
        if (row.hidden) return; // ausgeblendete LED-Zeilen nicht mitbestellen
        var gid = row.getAttribute('data-variant-id') || '';
        var id = parseInt(gid.split('/').pop(), 10);
        var qty = parseInt(row.getAttribute('data-calc-qty-now'), 10);
        if (isNaN(qty)) qty = parseInt(row.getAttribute('data-qty'), 10) || 1;
        if (id && qty > 0) items.push({ id: id, quantity: qty });
      });
      if (!items.length) return;
      var original = btn.textContent;
      btn.disabled = true;
      btn.textContent = btn.getAttribute('data-label-adding') || '…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        btn.textContent = btn.getAttribute('data-label-added') || original;
        var link = section.querySelector('[data-calc-cart-link]');
        if (link) link.hidden = false;
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 4000);
      }).catch(function () {
        btn.textContent = btn.getAttribute('data-label-error') || original;
        setTimeout(function () { btn.disabled = false; btn.textContent = original; }, 4000);
      });
    });
  }

  // Sprungnav unter dem Shop-Header andocken: Dawn blendet den Sticky-Header beim
  // Hochscrollen ein (Transform) — wir folgen seiner sichtbaren Unterkante.
  function initStickyNav() {
    var inner = document.querySelector('.hafa-kalk-nav');
    if (!inner) return;
    var nav = inner.closest('.shopify-section') || inner;
    var header = document.querySelector('.section-header .header-wrapper') || document.querySelector('.section-header');
    if (!header) return;
    var base = parseFloat(getComputedStyle(nav).getPropertyValue('--kalk-nav-top')) || 0;
    var ticking = false;
    function update() {
      ticking = false;
      var bottom = header.getBoundingClientRect().bottom;
      nav.style.top = Math.max(base, Math.round(bottom)) + 'px';
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var sections = document.querySelectorAll('[data-hafa-calc]');
    fmt = buildFormatter();
    initStickyNav();
    if (!sections.length) return;

    sections.forEach(function (s) {
      initControls(s);
      initAddToCart(s);
      calcSection(s);
    });

    fetch(SHEET_URL)
      .then(function (r) { return r.ok ? r.text() : Promise.reject(); })
      .then(function (csv) {
        var m = parseCSVToMatrix(csv);
        if (matrixLooksValid(m)) {
          matrix = m;
          sections.forEach(calcSection);
        }
      })
      .catch(function () { /* Fallback bleibt aktiv */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
